import { combineReducers } from "redux";
import searchState from './SearchState';
import currentUser from './CurrentUser';


export const rootReducer = combineReducers({
    searchState,
    currentUser
});